module.exports = __webpack_public_path__ + "img/数字经济产业园顶部.de3b61ce.png";